import { Accordion, AccordionTab } from "primereact/accordion";
import "./form-visit-attachment.scss";
import { VisitFormSchema } from "@factory/form/form.rule";
import { useFormContext } from "react-hook-form";
import ImageControl from "@shared/ui/hook-form/image-control/image-control";
import { Button } from "primereact/button";
import {
  useQyAttachFileVisit,
  useQyGetAttachmentVisit,
} from "@factory/query/visit.query";
import { useParams } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  GetAttachmentVisitModel,
  GetResponseAttachmentVisitModel,
} from "@factory/model/query-model-visit";
import { useState } from "react";
import { viewAsset } from "@factory/query/google-cloud-storage.query";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import SkeletonAttachment from "@shared/ui/skeleton-attachment/skeleton-attachment";
/* eslint-disable-next-line */
export interface FormVisitAttachmentProps {}

export function FormVisitAttachment() {
  const { formatDateLocal } = useDateTimeContext();
  const { control, watch } = useFormContext<VisitFormSchema>();
  const attachmentFile = watch("attachment");
  const { visitId } = useParams();
  const [responseData, setResponseData] = useState<GetAttachmentVisitModel[]>(
    []
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // API
  const { mutate: addAttachment, isLoading: isAddingAttachment } =
    useQyAttachFileVisit();

  const handleAdd = () => {
    console.log({ visitId });
    if (!visitId) {
      return;
    }
    addAttachment({
      attachment: {
        visit: visitId,
        attachment: "",
      },
      file: attachmentFile,
    });
  };

  const handleSuccessGetAttachment = async (
    response: GetResponseAttachmentVisitModel
  ) => {
    setIsLoading(true);
    const _responseData = response.data || [];

    if (_responseData.length === 0) {
      setIsLoading(false);
      return;
    }

    const updatedResponse = await Promise.all(
      _responseData.map(async (element) => {
        if (element.attach_file) {
          try {
            const elementFile = await viewAsset(element.attach_file);
            const fileBlob = URL.createObjectURL(elementFile);
            return { ...element, fileBlob };
          } catch (error) {
            console.error("Error fetching signature data:", error);
            return { ...element, fileBlob: null };
          }
        } else {
          return { ...element, fileBlob: null };
        }
      })
    );
    setResponseData(updatedResponse);
    setIsLoading(false);
  };

  const { isLoading: isQueryLoading } = useQyGetAttachmentVisit(
    "",
    9999,
    0,
    undefined,
    { visit: visitId ?? "" },
    !!visitId,
    handleSuccessGetAttachment
  );

  const showSkeleton = isLoading || isQueryLoading;

  return (
    <div id="FormVisitAttachment" className="form-visit-attachment">
      {/* <div className="mb-4">
        <Accordion>
          <AccordionTab
            header={
              <span className="flex align-items-center justify-content-between w-full">
                <span className="font-bold white-space-nowrap">
                  Add Attachment
                </span>
                <Button
                  label={isAddingAttachment ? "Uploading..." : "Upload File"}
                  severity="secondary"
                  outlined
                  onClick={handleAdd}
                  size="small"
                  disabled={isAddingAttachment || !attachmentFile}
                  loading={isAddingAttachment}
                />
              </span>
            }
          >
            <ImageControl<VisitFormSchema>
              control={control}
              name="attachment"
              label="Attachment"
              imagePreviewClass="w-32 h-32"
            />
          </AccordionTab>
        </Accordion>
      </div> */}

      <h5 className="mb-2">
        Total: <b>{showSkeleton ? "Loading..." : responseData.length}</b>
      </h5>

      {showSkeleton ? (
        <SkeletonAttachment count={3} mode="table" />
      ) : (
        <DataTable
          value={responseData}
          tableStyle={{ minWidth: "50rem" }}
          emptyMessage="No attachments found"
        >
          <Column
            body={(cell) => formatDateLocal(cell.updated_at)}
            field="updated_at"
            header="Date"
          />
          <Column
            field="photo"
            header="Attachment"
            body={(rowData) => (
              <img
                src={rowData.fileBlob}
                alt="attachment file"
                style={{
                  width: "200px",
                  height: "200px",
                  objectFit: "cover",
                }}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            )}
          />
        </DataTable>
      )}
    </div>
  );
}

export default FormVisitAttachment;
